var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSftp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "selectSFTP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Catalogue-des-Sources",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "selectSFTP"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "server-security-(1)",
    transform: "translate(24.000000, 12.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,0 L25.5,0 C26.3284271,0 27,0.651222182 27,1.45454545 L27,7.27272727 C27,8.07605055 26.3284271,8.72727273 25.5,8.72727273 L1.5,8.72727273 C0.671572875,8.72727273 0,8.07605055 0,7.27272727 L0,1.45454545 C0,0.651222182 0.671572875,0 1.5,0 M1.5,11.6363636 L25.5,11.6363636 C26.3284271,11.6363636 27,12.2875858 27,13.0909091 L27,14.0654545 L23.25,12.4509091 L13.5,16.64 L13.5,20.3636364 L1.5,20.3636364 C0.671572875,20.3636364 0,19.7124142 0,18.9090909 L0,13.0909091 C0,12.2875858 0.671572875,11.6363636 1.5,11.6363636 M1.5,23.2727273 L13.5,23.2727273 C13.59,26.5454545 15,29.6727273 17.19,32 L1.5,32 C0.671572875,32 0,31.3487778 0,30.5454545 L0,24.7272727 C0,23.9239495 0.671572875,23.2727273 1.5,23.2727273 M9,5.81818182 L10.5,5.81818182 L10.5,2.90909091 L9,2.90909091 L9,5.81818182 M9,17.4545455 L10.5,17.4545455 L10.5,14.5454545 L9,14.5454545 L9,17.4545455 M9,29.0909091 L10.5,29.0909091 L10.5,26.1818182 L9,26.1818182 L9,29.0909091 M3,2.90909091 L3,5.81818182 L6,5.81818182 L6,2.90909091 L3,2.90909091 M3,14.5454545 L3,17.4545455 L6,17.4545455 L6,14.5454545 L3,14.5454545 M3,26.1818182 L3,29.0909091 L6,29.0909091 L6,26.1818182 L3,26.1818182 M23.25,16 L30,18.9090909 L30,23.2727273 C30,27.3163636 27.12,31.0836364 23.25,32 C19.38,31.0836364 16.5,27.3163636 16.5,23.2727273 L16.5,18.9090909 L23.25,16 M23.25,18.8218182 L19.5,20.4509091 L19.5,24.32 C19.5,26.56 21.105,28.6545455 23.25,29.1781818 L23.25,18.8218182 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSftp);
export default __webpack_public_path__ + "static/media/sftp.941971455abb8ec0bae6fa1f67fd6015.svg";
export { ForwardRef as ReactComponent };